import { Injectable } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { first } from 'rxjs/operators'
import { RmsLoadingSpinnerComponent } from './rms-loading-spinner.component';

@Injectable()
export class RmsLoadingSpinnerService {

  public bsModalRef: BsModalRef;

  constructor(private modalService: BsModalService) { 

  }

  showModal(message: string = '') {
    let activeElement = document.activeElement;

    this.bsModalRef = this.modalService.show(RmsLoadingSpinnerComponent, { backdrop: 'static', class: 'gray modal-sm' });
    this.bsModalRef.content.message = message;

    this.bsModalRef.onHide.pipe(first()).subscribe(() => {
      if (activeElement && activeElement instanceof HTMLElement) {
        activeElement.focus();
        activeElement.blur();
      }
    });
  }

  hideModal() {
    if (this.bsModalRef) {
      setTimeout(() => {
        this.bsModalRef.hide();
      }, 1000);
    }
  }

}
